import { useQuery } from 'react-query';
import request from '../../../../../../helpers/request';
import { getQueryKeys } from '../../../../queries/queryKeys';

const fetchArrearInfo = async ({ houseIds }) => {
  const res = await request.post(
    `/HousingStock/house/arrear_info`,
    { houseIds },
    'Не удалось загрузить типы ЛС'
  );

  return res;
};

const useArrearInfo = (params = {}, options = {}) =>
  useQuery(
    getQueryKeys.arrearInfo(params),
    () => fetchArrearInfo(params),
    options
  );

export { useArrearInfo };
